import React, { Component } from 'react';
import FormInput from './FormInput';
import {Validate} from "../../actions/FormHandler.js";

export default class FormInputContainer extends Component{

    componentDidMount(){
        if(this.props.mask !== undefined){
            $(`#${this.props.input_id}`).inputmask({"mask": this.props.mask})
        }
    }

    changeHandler(){
        Validate();
    }

    render(){
        return(
            <div className="form__field__container">
                <span>{this.props.label}</span>
                <label style={{width: '100%', marginTop: '5px'}}>
                    <div className="icon__container">
                        <i className={this.props.icon + ' form_icon'}></i>
                        <FormInput
                            value={this.props.value}
                            placeholder={this.props.placeholder}
                            onChangeHandler={this.changeHandler}
                            readOnly={this.props.readOnly}
                            name={this.props.name}
                            id={this.props.input_id}
                        />
                    </div>
                </label>
                <div className="form-error" id={this.props.input_id + '-error'}>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/FormInputContainer.js